import gql from 'graphql-tag';

export default gql`
query listFA_InvoiceListNew($filter: FA_InvoiceListNewFilterInput!){
    fakturaAssist{
    	listFA_InvoiceListNew(filter: $filter){
    		id
    		nameRes
    		productNr
			sammelfakturaAufKunde
 		}
 	}
}`;
